import { Text } from "@blueprintjs/core";
import classNames from "classnames";
import moment from "moment";
import { memo, useCallback, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { setSelectedConversationId } from "src/actions/conversations/conversations";
import { acceptConversation } from "src/actions/conversations/conversations-api";
import { Avatar, StyledButton, Tag } from "src/components";
import { MPDIcon } from "src/mpd-library";
import { senderSelector } from "src/selectors";
import { AppState } from "src/store";
import { ConversationStatusLabel } from "../conversation-status-label/conversation-status-label";
import styles from "./styles.module.scss";
import { ReactComponent as RatingStarIcon } from "src/mpd-library/icon/assets/rating-star.svg";

const classname = "conversation-card";

// const avatarUrlMock =
//     "data:image/jpeg;base64,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";
interface ConversationCardProps {
    loading: boolean;
    item: any;
    isSearching?: boolean;
    type: ConversationCardType;
}

export const ConversationCardTypes = {
    DEFAULT: "default",
    PREVIOUS_WITH_SENDER: "previous-with-sender"
};

export type ConversationCardType = (typeof ConversationCardTypes)[keyof typeof ConversationCardTypes];

export const ConversationCard = memo(
    ({
        loading,
        isSearching = false,
        type = "default",
        item: {
            tags,
            id,
            status,
            unread_count,
            user_identity_hidden,
            spam,
            updated_at,
            channel,
            last_message_summary,
            starred
        }
    }: ConversationCardProps) => {
        const skeletonClass = loading ? "bp4-skeleton" : "";

        const userSelector = useMemo(() => senderSelector(), [id]);

        const user = useSelector((state: AppState) => userSelector(state, id));

        const dispatch = useDispatch();

        const selectedConversationId = useSelector((state: AppState) => state.conversations.selectedConversationId);

        const selectedClass = id === selectedConversationId ? "selected" : "";

        const history = useHistory();

        const [isCardHovered, setIsCardHovered] = useState(false);
        const [acceptConversationProcessingStatus, setAcceptConversationProcessingStatus] = useState(false);

        const onCardHovered = () => {
            setIsCardHovered(true);
        };

        const onCardUnhovered = () => {
            setIsCardHovered(false);
        };

        const onAcceptClick = useCallback(
            (event: any) => {
                event.stopPropagation();
                const acceptConversationPromise = async () => {
                    try {
                        setAcceptConversationProcessingStatus(true);
                        await dispatch(acceptConversation(id));
                        history.push(`/conversations/${id}`);
                    } finally {
                        setAcceptConversationProcessingStatus(false);
                    }
                };
                acceptConversationPromise();
            },
            [id]
        );

        const onClickCard = useCallback(() => {
            dispatch(setSelectedConversationId(id));
            history.push(`/conversations/${id}`);
        }, [id]);

        const updatedFromNow = useMemo(() => moment(updated_at).locale("en-cust2").fromNow(), [updated_at]);

        const displayedName = useMemo(() => {
            const { first_name, last_name, contacts } = user || {};
            const { phone_number, email } = contacts || {};
            if (first_name) {
                return `${user?.first_name} ${last_name || ""}`;
            } else if (phone_number) {
                return phone_number;
            } else if (email) {
                return email;
            } else {
                return "Unamed user";
            }
        }, [user]);

        if (type === ConversationCardTypes.PREVIOUS_WITH_SENDER) {
            return (
                <div
                    className={classNames(styles[classname], styles[ConversationCardTypes.PREVIOUS_WITH_SENDER])}
                    onClick={onClickCard}
                >
                    <div className={classNames(styles[`${classname}-top-wrapper`], skeletonClass)}>
                        <ConversationStatusLabel status={status} />

                        <Text className={classNames(styles[`${classname}-date`])}>{updatedFromNow}</Text>
                    </div>
                    <Text className={classNames(styles[`${classname}-last-message`], skeletonClass)}>
                        {last_message_summary}
                    </Text>
                </div>
            );
        }

        if (type === ConversationCardTypes.DEFAULT) {
            return (
                <div
                    className={classNames(
                        styles[classname],
                        id && styles[selectedClass],
                        starred && styles["starred"],
                        styles[ConversationCardTypes.DEFAULT]
                    )}
                    onClick={onClickCard}
                    onMouseEnter={onCardHovered}
                    onMouseLeave={onCardUnhovered}
                >
                    <div className={styles[`${classname}-shifted-wrapper`]}>
                        <Avatar
                            avatarUrl={user?.profile_pic?.url}
                            status={user?.status}
                            user={user}
                            className={classNames(styles[`${classname}-avatar`], skeletonClass)}
                            anonimousUser={user_identity_hidden}
                            channel={channel}
                        />
                        <div className={styles[`${classname}-main-info-wrapper`]}>
                            <div className={classNames(styles[`${classname}-name-and-date-wrapper`], skeletonClass)}>
                                <div className={styles[`${classname}-name-and-tags-wrapper`]}>
                                    <Text className={styles[`${classname}-name`]}>
                                        {!user_identity_hidden ? displayedName : `Profile Hidden`}
                                    </Text>
                                    {user?.starred && (
                                        <MPDIcon
                                            IconComponent={RatingStarIcon}
                                            className={styles[`${classname}-star`]}
                                        />
                                    )}
                                    {!!user?.blocked && (
                                        <div className={styles[`${classname}-block-tag-wrapper`]}>
                                            <Tag
                                                label={"Blocked"}
                                                className={`${styles[`${classname}-block-tag-wrapper`]} ${
                                                    styles[`${selectedClass}`]
                                                }`}
                                            />
                                        </div>
                                    )}
                                </div>
                                <div className={styles[`${classname}-button-date-wrapper`]}>
                                    {isCardHovered && status === "opened" ? (
                                        <StyledButton
                                            type={"secondary"}
                                            text={"Accept"}
                                            onClick={onAcceptClick}
                                            processing={acceptConversationProcessingStatus}
                                            className={styles[`${classname}-accept-button`]}
                                        />
                                    ) : (
                                        <Text className={`${styles[`${classname}-date`]}`}>{updatedFromNow}</Text>
                                    )}
                                </div>
                            </div>

                            <div className={classNames(styles[`${classname}-last-message-wrapper`], skeletonClass)}>
                                <Text className={classNames(styles[`${classname}-last-message`])}>
                                    {last_message_summary}
                                </Text>
                                {!loading && unread_count > 0 && (
                                    <div className={styles[`${classname}-unread-marker`]}>{unread_count}</div>
                                )}
                            </div>

                            <div className={classNames(styles[`${classname}-tags-wrapper`], skeletonClass)}>
                                {isSearching && <ConversationStatusLabel status={status} />}
                                {tags?.map((tag) => {
                                    return (
                                        <Tag
                                            key={tag.id}
                                            label={tag.name}
                                            className={classNames(
                                                styles[`${classname}-tag-wrapper`],
                                                styles[`${selectedClass}`]
                                            )}
                                        />
                                    );
                                })}
                                {spam && (
                                    <Tag
                                        label={"Spam"}
                                        className={classNames(
                                            styles[`${classname}-spam-tag-wrapper`],
                                            styles[`${selectedClass}`]
                                        )}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
    }
);
